import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { FaTimes, FaSearch, FaSpinner } from 'react-icons/fa';

const ClienteModal = ({ show, onClose, cliente, onSave, mode }) => {
    const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;

    const [formData, setFormData] = useState({
        cnpj: '',
        ie: '',
        cpf: '',
        rg: '',
        nome: '',
        razao: '',
        endereco: '',
        complemento: '',
        bairro: '',
        numero: '',
        cep: '',
        uf: '',
        cidade: '',
        ibge: '',
        email1: '',
        email2: '',
        email3: '',
        email4: '',
        dia_vencimento: 0,
        valor_servico: 0.0,
        pvencto: '',
        gerar_boleto: 'N',
        gerar_nfse: 'N',
        obs: '',
        tipo_pessoa: 'PESSOA_JURIDICA',
        id_emitente: localStorage.getItem('userIdEmitente') || 0,
        ativo: 'S',
        status: 'Ativo',
        foneContato: '',
        foneFinanceiro: '',
        imprimir_boleto: 'N',
        usa_app: 'N',
        decimo_terceiro: 0,
        comissao_cobranca: 0
    });

    const [loading, setLoading] = useState(false);
    const [loadingCnpj, setLoadingCnpj] = useState(false);
    const [ufs, setUfs] = useState([]);
    const [cidades, setCidades] = useState([]);
    const [loadingUfs, setLoadingUfs] = useState(false);
    const [loadingCidades, setLoadingCidades] = useState(false);

    // Mapeamento de sigla para código do estado
    const estadosArray = useMemo(() => ({
        'AC': 12, 'AL': 27, 'AM': 13, 'AP': 16, 'BA': 29, 'CE': 23, 'DF': 53, 'ES': 32, 'GO': 52, 'MA': 21,
        'MG': 31, 'MS': 50, 'MT': 51, 'PA': 15, 'PB': 25, 'PE': 26, 'PI': 22, 'PR': 41, 'RJ': 33, 'RN': 24,
        'RO': 11, 'RR': 14, 'RS': 43, 'SC': 42, 'SE': 28, 'SP': 35, 'TO': 17
    }), []);

    const getCodigoEstado = (sigla) => {
        return estadosArray[sigla.toUpperCase()] || null;
    };

    // Helpers
    const resolveTipoPessoa = (c) => {
        // tenta várias formas comuns que podem vir do backend
        const bruto =
            c?.tipo_pessoa ??
            c?.tipoPessoa ??
            c?.tipo ??
            c?.pf_pj ??
            c?.pessoa ??
            '';

        const norm = String(bruto).toUpperCase();

        if (norm === 'PESSOA_FISICA' || norm === 'PF' || norm === 'FISICA') return 'PESSOA_FISICA';
        if (norm === 'PESSOA_JURIDICA' || norm === 'PJ' || norm === 'JURIDICA') return 'PESSOA_JURIDICA';

        // fallback inteligente: se tem CNPJ -> PJ, senão se tem CPF -> PF
        if (c?.cnpj) return 'PESSOA_JURIDICA';
        if (c?.cpf) return 'PESSOA_FISICA';

        // último recurso: mantenha PJ (ou mude aqui se preferir PF)
        return 'PESSOA_JURIDICA';
    };

    // Carrega UFs apenas uma vez na montagem
    useEffect(() => {
        const fetchUfs = async () => {
            setLoadingUfs(true);
            try {
                const { data } = await axios.get(`${URL_BACKEND}/estados`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('userToken')}` }
                });
                if (data) {
                    setUfs(data);
                }
            } catch (error) {
                console.error('Erro ao buscar estados:', error);
                alert('Erro ao carregar a lista de estados.');
            } finally {
                setLoadingUfs(false);
            }
        };
        fetchUfs();
    }, [URL_BACKEND]);

    // Carrega cidades quando a UF muda
    useEffect(() => {
        const fetchCidades = async (ufId) => {
            if (!ufId || ufId === '') {
                setCidades([]);
                setLoadingCidades(false);
                return;
            }

            setLoadingCidades(true);

            try {
                const response = await axios.get(`${URL_BACKEND}/cidades/${ufId}`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('userToken')}` }
                });


                if (response.data && Array.isArray(response.data)) {
                    setCidades(response.data);
                } else {
                    console.warn('Dados de cidades inválidos:', response.data);
                    setCidades([]);
                }
            } catch (error) {
                console.error('Erro ao buscar cidades:', error);
                if (error.response) {
                    console.error('Status:', error.response.status);
                    console.error('Data:', error.response.data);
                }
                alert('Erro ao carregar a lista de cidades. Verifique se o estado foi selecionado corretamente.');
                setCidades([]);
            } finally {
                setLoadingCidades(false);
            }
        };

        // Só busca cidades se a UF for válida e não estiver vazia
        if (formData.uf && formData.uf !== '') {
            fetchCidades(formData.uf);
        } else {
            setCidades([]);
            setLoadingCidades(false);
        }
    }, [formData.uf, URL_BACKEND]);

    // Inicializa o formulário ao abrir o modal - CORRIGIDO
    useEffect(() => {
        if (show) {
            if (cliente && (mode === 'edit' || mode === 'view')) {
                // Para modo de edição, primeiro define os dados do cliente
                const clienteData = {
                    ...cliente,
                    valor_servico: parseFloat(cliente.valor_servico) || 0.0,
                    decimo_terceiro: parseFloat(cliente.valor_decimo_terceiro) || 0.0,
                    dia_vencimento: parseInt(cliente.dia_vencimento) || 0,
                    // Garantir que uf e cidade sejam números se necessário
                    // uf: cliente.uf ? parseInt(cliente.uf, 10) : '',
                    // cidade: cliente.id_cidade ? parseInt(cliente.id_cidade, 10) : '',
                    // UF e cidade podem vir como string; normaliza para número ou vazio
                    uf: cliente.uf !== undefined && cliente.uf !== null && cliente.uf !== ''
                        ? parseInt(cliente.uf, 10)
                        : '',

                    cidade: cliente.id_cidade !== undefined && cliente.id_cidade !== null && cliente.id_cidade !== ''
                        ? parseInt(cliente.id_cidade, 10)
                        : '',

                    // 👇 AQUI ESTÁ O PULO DO GATO
                    tipo_pessoa: resolveTipoPessoa(cliente),
                    comissao_cobranca: cliente.porcentagem_comissao
                };

                setFormData(clienteData);

            } else if (cliente && mode === 'view') {
                // Para modo de visualização
                const clienteData = {
                    ...cliente,
                    valor_servico: parseFloat(cliente.valor_servico) || 0.0,
                    dia_vencimento: parseInt(cliente.dia_vencimento) || 0,
                    uf: cliente.uf ? parseInt(cliente.uf, 10) : '',
                    cidade: cliente.id_cidade ? parseInt(cliente.id_cidade, 10) : '',
                };

                setFormData(clienteData);

            } else if (mode === 'create') {
                // Modo de criação: limpa o formulário
                setFormData({
                    cnpj: '', ie: '', cpf: '', rg: '', nome: '', razao: '', endereco: '',
                    complemento: '', bairro: '', numero: '', cep: '', uf: '', cidade: '',
                    ibge: '', email1: '', email2: '', email3: '', email4: '',
                    dia_vencimento: 0, valor_servico: 0.0, pvencto: '', gerar_boleto: 'N',
                    gerar_nfse: 'N', obs: '', tipo_pessoa: 'PESSOA_JURIDICA',
                    id_emitente: localStorage.getItem('userIdEmitente') || 0,
                    ativo: 'S', status: 'Ativo', foneContato: '', foneFinanceiro: '',
                    imprimir_boleto: 'N', usa_app: 'N'
                });
                setCidades([]);
            }
        }
    }, [show, cliente, mode]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        console.log(name, value, type, checked);

        if (name === 'tipo_pessoa') {
            setFormData(prev => ({
                ...prev,
                tipo_pessoa: value,
                cpf: value === 'PESSOA_FISICA' ? prev.cpf : '',
                cnpj: value === 'PESSOA_JURIDICA' ? prev.cnpj : '',
                ie: value === 'PESSOA_JURIDICA' ? prev.ie : ''
            }));
            return;
        }
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? (checked ? 'S' : 'N') : value,
        }));
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const apiPath = mode === 'create' ? '/createCliente' : `/cliente/${formData.id}`;
        const method = mode === 'create' ? 'POST' : 'PUT';

        try {
            const response = await axios({
                method: method,
                url: `${URL_BACKEND}${apiPath}`,
                data: formData,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('userToken')}`,
                },
            });

            if (response.status === 200 || response.status === 201) {
                alert(`Cliente ${mode === 'create' ? 'criado' : 'atualizado'} com sucesso!`);
                onSave();
                onClose();
            }
        } catch (error) {
            console.error('Erro ao salvar cliente:', error);
            alert(error.response?.data?.message || `Erro ao ${mode === 'create' ? 'criar' : 'atualizar'} cliente.`);
        } finally {
            setLoading(false);
        }
    };

    // Função para buscar dados na Receita Federal
    const handleConsultaCnpj = async () => {
        const cnpjLimpo = formData.cnpj.replace(/\D/g, '');
        if (!cnpjLimpo || cnpjLimpo.length !== 14) {
            alert('CNPJ inválido. Digite 14 dígitos numéricos.');
            return;
        }

        setLoadingCnpj(true);
        try {
            const retorno = await axios.get(`${URL_BACKEND}/consultaCnpj/${cnpjLimpo}`);

            if (retorno && retorno.data) {
                const ufSigla = retorno.data.uf || '';

                // Usa o mapeamento manual para converter sigla para código
                const codigoEstado = getCodigoEstado(ufSigla);

                // Verifica se o código existe no array de estados
                const estadoExiste = ufs.find(estado => {
                    const estadoId = estado.id || estado.codigo || estado.uf_id;
                    return estadoId === codigoEstado;
                });


                // Preenche os dados do formulário
                setFormData(prevData => ({
                    ...prevData,
                    nome: retorno.data.fantasia || '',
                    razao: retorno.data.nome || '',
                    endereco: retorno.data.logradouro || '',
                    numero: retorno.data.numero || '',
                    bairro: retorno.data.bairro || '',
                    cep: retorno.data.cep || '',
                    uf: codigoEstado || '', // Usa o código do mapeamento manual
                    cidade: '', // Limpa a cidade para ser selecionada depois
                    ibge: '',
                }));

                if (codigoEstado && estadoExiste) {
                    alert('Dados do CNPJ preenchidos com sucesso! As cidades estão sendo carregadas. Aguarde e selecione a cidade.');
                } else if (codigoEstado && !estadoExiste) {
                    alert('Dados do CNPJ preenchidos, mas o estado não foi encontrado na lista. Selecione manualmente o estado e a cidade.');
                } else {
                    alert('Dados do CNPJ preenchidos, mas não foi possível identificar o estado. Selecione manualmente o estado e a cidade.');
                }
            } else {
                alert('Não foi possível encontrar dados para o CNPJ informado.');
            }
        } catch (error) {
            console.error('Erro ao consultar CNPJ:', error);
            alert(error.response?.data?.message || 'Erro ao consultar CNPJ. Verifique o número e tente novamente.');
        } finally {
            setLoadingCnpj(false);
        }
    };

    const getModalTitle = () => {
        switch (mode) {
            case 'create': return 'Cadastrar Novo Cliente';
            case 'edit': return `Editar Cliente: ${cliente?.nome}`;
            case 'view': return `Visualizar Cliente: ${cliente?.nome}`;
            default: return 'Cliente';
        }
    };

    if (!show) return null;

    const isViewMode = mode === 'view';

    const handleUfChange = (e) => {
        const newUfId = e.target.value;

        // Converte para número se necessário
        const ufIdNumerico = newUfId ? parseInt(newUfId, 10) : '';

        setFormData(prevData => ({
            ...prevData,
            uf: ufIdNumerico,
            cidade: '', // Limpa a cidade quando muda UF
            ibge: ''   // Limpa o IBGE quando muda UF
        }));
    };

    const handleCidadeChange = (e) => {
        const cidadeId = e.target.value;

        if (cidadeId && cidadeId !== '') {
            const idCidNumerico = parseInt(cidadeId, 10);
            const cidadeEncontrada = cidades.find((cid) => cid.id === idCidNumerico);

            setFormData(prevData => ({
                ...prevData,
                cidade: idCidNumerico,
                ibge: cidadeEncontrada ? cidadeEncontrada.codigo_ibge : ''
            }));
        } else {
            setFormData(prevData => ({
                ...prevData,
                cidade: '',
                ibge: ''
            }));
        }
    };

    // Função para aplicar máscara
    const onlyDigits = (v) => (v || '').replace(/\D/g, '');

    const formatCPF = (v) => {
        const d = onlyDigits(v).slice(0, 11);
        return d
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    };

    const formatCNPJ = (v) => {
        const d = onlyDigits(v).slice(0, 14);
        return d
            .replace(/^(\d{2})(\d)/, '$1.$2')
            .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
            .replace(/\.(\d{3})(\d)/, '.$1/$2')
            .replace(/(\d{4})(\d)/, '$1-$2');
    };

    return (
        <div style={modalStyles.overlay}>
            <div style={modalStyles.modal}>
                <div style={modalStyles.header}>
                    <h2 style={modalStyles.title}>{getModalTitle()}</h2>
                    <button onClick={onClose} style={modalStyles.closeButton}>
                        <FaTimes />
                    </button>
                </div>
                <div style={modalStyles.body}>
                    <form onSubmit={handleFormSubmit} style={modalStyles.form}>
                        {/* Tipo de Pessoa */}
                        <div style={modalStyles.section}>
                            <h3 style={modalStyles.sectionTitle}>Informações Básicas</h3>
                            <div style={modalStyles.formRow}>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>Tipo de Pessoa:</label>
                                    <select
                                        name="tipo_pessoa"
                                        value={formData.tipo_pessoa || 'PESSOA_JURIDICA'}
                                        onChange={handleChange}
                                        style={modalStyles.select}
                                        disabled={isViewMode}
                                    >
                                        <option value="PESSOA_JURIDICA">Pessoa Jurídica</option>
                                        <option value="PESSOA_FISICA">Pessoa Física</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* Campos de Identificação */}
                        <div style={modalStyles.section}>
                            <h3 style={modalStyles.sectionTitle}>Documentos</h3>
                            <div style={modalStyles.formRow}>
                                {formData.tipo_pessoa === 'PESSOA_JURIDICA' ? (
                                    <>
                                        <div style={modalStyles.formGroupCnpj}>
                                            <label style={modalStyles.label}>CNPJ:</label>
                                            <div style={modalStyles.cnpjInputGroup}>
                                                <input
                                                    type="text"
                                                    name="cnpj"
                                                    value={formData.cnpj}
                                                    onChange={(e) => {
                                                        const masked = formatCNPJ(e.target.value);
                                                        setFormData(prev => ({ ...prev, cnpj: masked }));
                                                    }}
                                                    style={modalStyles.inputCnpj}
                                                    disabled={isViewMode}
                                                    placeholder="00.000.000/0000-00"
                                                    maxLength={18}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={handleConsultaCnpj}
                                                    style={modalStyles.cnpjSearchButton}
                                                    disabled={isViewMode || loadingCnpj}
                                                >
                                                    {loadingCnpj ? <FaSpinner className="fa-spin" /> : <FaSearch />}
                                                </button>
                                            </div>
                                        </div>
                                        <div style={modalStyles.formGroup}>
                                            <label style={modalStyles.label}>Inscrição Estadual (IE):</label>
                                            <input type="text" name="ie" value={formData.ie} onChange={handleChange} style={modalStyles.input} disabled={isViewMode} />
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div style={modalStyles.formGroup}>
                                            <label style={modalStyles.label}>CPF:</label>
                                            <input
                                                type="text"
                                                name="cpf"
                                                value={formData.cpf}
                                                onChange={(e) => {
                                                    const masked = formatCPF(e.target.value);
                                                    setFormData(prev => ({ ...prev, cpf: masked }));
                                                }}
                                                style={modalStyles.input}
                                                disabled={isViewMode}
                                                placeholder="000.000.000-00"
                                                maxLength={14}
                                            />
                                        </div>
                                        <div style={modalStyles.formGroup}>
                                            <label style={modalStyles.label}>RG:</label>
                                            <input type="text" name="rg" value={formData.rg} onChange={handleChange} style={modalStyles.input} disabled={isViewMode} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                        {/* Nome/Razão Social */}
                        <div style={modalStyles.section}>
                            <h3 style={modalStyles.sectionTitle}>Identificação</h3>
                            <div style={modalStyles.formRow}>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>{formData.tipo_pessoa === 'PESSOA_JURIDICA' ? 'Razão Social:' : 'Nome Completo:'}</label>
                                    <input
                                        type="text"
                                        name={formData.tipo_pessoa === 'PESSOA_JURIDICA' ? 'razao' : 'nome'}
                                        value={formData.tipo_pessoa === 'PESSOA_JURIDICA' ? formData.razao : formData.nome}
                                        onChange={handleChange}
                                        style={modalStyles.input}
                                        required
                                        disabled={isViewMode}
                                    />
                                </div>
                                {formData.tipo_pessoa === 'PESSOA_JURIDICA' && (
                                    <div style={modalStyles.formGroup}>
                                        <label style={modalStyles.label}>Nome Fantasia:</label>
                                        <input type="text" name='nome' value={formData.nome} onChange={handleChange} style={modalStyles.input} disabled={isViewMode} />
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Endereço */}
                        <div style={modalStyles.section}>
                            <h3 style={modalStyles.sectionTitle}>Endereço</h3>
                            <div style={modalStyles.formRow}>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>CEP:</label>
                                    <input type="text" name="cep" value={formData.cep} onChange={handleChange} style={modalStyles.input} disabled={isViewMode} />
                                </div>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>Endereço:</label>
                                    <input type="text" name="endereco" value={formData.endereco} onChange={handleChange} style={modalStyles.input} disabled={isViewMode} />
                                </div>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>Número:</label>
                                    <input type="text" name="numero" value={formData.numero} onChange={handleChange} style={modalStyles.input} disabled={isViewMode} />
                                </div>
                            </div>

                            <div style={modalStyles.formRow}>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>Bairro:</label>
                                    <input type="text" name="bairro" value={formData.bairro} onChange={handleChange} style={modalStyles.input} disabled={isViewMode} />
                                </div>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>UF:</label>
                                    <select
                                        name="uf"
                                        value={formData.uf || ''}
                                        onChange={handleUfChange}
                                        style={modalStyles.select}
                                        disabled={isViewMode || loadingUfs}
                                    >
                                        <option value="">Selecione um estado...</option>
                                        {loadingUfs ? (
                                            <option value="" disabled>Carregando...</option>
                                        ) : (
                                            ufs.map((uf, index) => {
                                                // Tenta diferentes propriedades comuns para ID
                                                const ufId = uf.id || uf.codigo || uf.codigo_uf || uf.uf_id || index + 1;
                                                const ufNome = uf.nome || uf.estado || uf.uf || uf.sigla;

                                                return (
                                                    <option key={ufId} value={ufId}>
                                                        {ufNome}
                                                    </option>
                                                );
                                            })
                                        )}
                                    </select>
                                    {loadingUfs && (
                                        <div style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '4px' }}>
                                            <FaSpinner className="fa-spin" style={{ marginRight: '4px' }} />
                                            Carregando estados...
                                        </div>
                                    )}
                                </div>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>Cidade:</label>
                                    <select
                                        name="cidade"
                                        value={formData.cidade || ''}
                                        onChange={handleCidadeChange}
                                        style={modalStyles.select}
                                        disabled={isViewMode || loadingCidades || !formData.uf}
                                    >
                                        <option value="">
                                            {!formData.uf
                                                ? 'Selecione um estado primeiro...'
                                                : loadingCidades
                                                    ? 'Carregando cidades...'
                                                    : 'Selecione uma cidade...'
                                            }
                                        </option>
                                        {!loadingCidades && cidades.length > 0 && (
                                            cidades.map(cidade => (
                                                <option key={cidade.id} value={cidade.id}>
                                                    {cidade.nome}
                                                </option>
                                            ))
                                        )}
                                        {!loadingCidades && formData.uf && cidades.length === 0 && (
                                            <option value="" disabled>
                                                Nenhuma cidade encontrada
                                            </option>
                                        )}
                                    </select>
                                    {loadingCidades && (
                                        <div style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '4px' }}>
                                            <FaSpinner className="fa-spin" style={{ marginRight: '4px' }} />
                                            Carregando cidades...
                                        </div>
                                    )}
                                </div>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>IBGE:</label>
                                    <input type="text" name="ibge" value={formData.ibge} onChange={handleChange} style={modalStyles.inputDisabled} disabled={true} />
                                </div>
                            </div>

                            <div style={modalStyles.formRow}>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>Complemento:</label>
                                    <input type="text" name="complemento" value={formData.complemento} onChange={handleChange} style={modalStyles.input} disabled={isViewMode} />
                                </div>
                            </div>
                        </div>

                        {/* Contatos */}
                        <div style={modalStyles.section}>
                            <h3 style={modalStyles.sectionTitle}>Contatos</h3>
                            <div style={modalStyles.formRow}>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>E-mail Principal:</label>
                                    <input type="email" name="email1" value={formData.email1} onChange={handleChange} style={modalStyles.input} disabled={isViewMode} />
                                </div>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>E-mail Secundário:</label>
                                    <input type="email" name="email2" value={formData.email2} onChange={handleChange} style={modalStyles.input} disabled={isViewMode} />
                                </div>
                            </div>
                            <div style={modalStyles.formRow}>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>E-mail 3:</label>
                                    <input type="email" name="email3" value={formData.email3} onChange={handleChange} style={modalStyles.input} disabled={isViewMode} />
                                </div>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>E-mail 4:</label>
                                    <input type="email" name="email4" value={formData.email4} onChange={handleChange} style={modalStyles.input} disabled={isViewMode} />
                                </div>
                            </div>
                            <div style={modalStyles.formRow}>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>Telefone Contato:</label>
                                    <input type="text" name="foneContato" value={formData.foneContato} onChange={handleChange} style={modalStyles.input} disabled={isViewMode} />
                                </div>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>Telefone Financeiro:</label>
                                    <input type="text" name="foneFinanceiro" value={formData.foneFinanceiro} onChange={handleChange} style={modalStyles.input} disabled={isViewMode} />
                                </div>
                            </div>
                        </div>

                        {/* Dados de Faturamento */}
                        <div style={modalStyles.section}>
                            <h3 style={modalStyles.sectionTitle}>Faturamento</h3>
                            <div style={modalStyles.formRow}>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>Dia Vencimento:</label>
                                    <input type="number" name="dia_vencimento" value={formData.dia_vencimento} onChange={handleChange} style={modalStyles.input} disabled={isViewMode} />
                                </div>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>Valor do Serviço:</label>
                                    <input type="number" name="valor_servico" value={formData.valor_servico} onChange={handleChange} style={modalStyles.input} step="0.01" disabled={isViewMode} />
                                </div>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>Valor Decimo Terceiro:</label>
                                    <input type="number" name="decimo_terceiro" value={formData.decimo_terceiro} onChange={handleChange} style={modalStyles.input} step="0.01" disabled={isViewMode} />
                                </div>
                                <div style={modalStyles.formGroup}>
                                    <label style={modalStyles.label}>% Comissão Cobrança:</label>
                                    <input type="number" name="comissao_cobranca" value={formData.comissao_cobranca} onChange={handleChange} style={modalStyles.input} step="0.01" disabled={isViewMode} />
                                </div>
                            </div>

                            {/* Opções de Geração */}
                            <div style={modalStyles.formRow}>
                                <div style={modalStyles.checkboxGroup}>
                                    <div style={modalStyles.formGroupCheckbox}>
                                        <input type="checkbox" name="gerar_boleto" checked={formData.gerar_boleto === 'S'} onChange={handleChange} style={modalStyles.checkbox} disabled={isViewMode} />
                                        <label style={modalStyles.labelCheckbox}>Gerar Boleto</label>
                                    </div>
                                    <div style={modalStyles.formGroupCheckbox}>
                                        <input type="checkbox" name="gerar_nfse" checked={formData.gerar_nfse === 'S'} onChange={handleChange} style={modalStyles.checkbox} disabled={isViewMode} />
                                        <label style={modalStyles.labelCheckbox}>Gerar NF-e</label>
                                    </div>
                                    <div style={modalStyles.formGroupCheckbox}>
                                        <input type="checkbox" name="usa_app" checked={formData.usa_app === 'S'} onChange={handleChange} style={modalStyles.checkbox} disabled={isViewMode} />
                                        <label style={modalStyles.labelCheckbox}>Usa APP</label>
                                    </div>
                                    <div style={modalStyles.formGroupCheckbox}>
                                        <input type="checkbox" name="imprimir_boleto" checked={formData.imprimir_boleto === 'S'} onChange={handleChange} style={modalStyles.checkbox} disabled={isViewMode} />
                                        <label style={modalStyles.labelCheckbox}>Imprimir Boleto</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Observações */}
                        <div style={modalStyles.section}>
                            <h3 style={modalStyles.sectionTitle}>Observações</h3>
                            <div style={modalStyles.formRow}>
                                <div style={modalStyles.formGroupFull}>
                                    <label style={modalStyles.label}>Observações:</label>
                                    <textarea name="obs" value={formData.obs} onChange={handleChange} style={modalStyles.textarea} disabled={isViewMode}></textarea>
                                </div>
                            </div>
                        </div>

                        {/* Botões de Ação */}
                        {!isViewMode && (
                            <div style={modalStyles.footer}>
                                <button type="button" onClick={onClose} style={modalStyles.cancelButton} disabled={loading}>
                                    Cancelar
                                </button>
                                <button type="submit" style={modalStyles.saveButton} disabled={loading}>
                                    {loading ? (
                                        <>
                                            <FaSpinner className="fa-spin" style={{ marginRight: '8px' }} />
                                            Salvando...
                                        </>
                                    ) : (
                                        'Salvar'
                                    )}
                                </button>
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </div>
    );
};


// Estilos modernos para o Modal
const modalStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        backdropFilter: 'blur(4px)',
    },
    modal: {
        backgroundColor: '#fff',
        borderRadius: '10px',
        width: '100%',
        maxWidth: '1000px',      // largura máxima
        margin: '0 16px',        // margem lateral em telas pequenas
        maxHeight: '90vh',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
        overflowY: 'auto',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 20px',
        background: 'linear-gradient(to right, #667eea, #764ba2)', // mesmo gradiente
        borderRadius: '16px 16px 0 0',
        color: '#fff', // texto branco
        borderBottom: 'none', // removi a borda para não quebrar o gradiente
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)' // leve sombra inferior
    },
    title: {
        margin: 0,
        fontSize: '1.25rem',
        fontWeight: '600'
    },
    closeButton: {
        backgroundColor: 'rgba(255,255,255,0.15)',
        border: '1px solid rgba(255,255,255,0.3)',
        borderRadius: '8px',
        fontSize: '1rem',
        color: '#fff',
        cursor: 'pointer',
        padding: '4px 8px',
        transition: 'background-color 0.2s ease',
    },
    body: {
        padding: '24px',
        flex: 1,
        backgroundColor: '#f8fafc',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
    },
    section: {
        backgroundColor: '#ffffff',
        padding: '20px',
        borderRadius: '12px',
        border: '1px solid #e5e7eb',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    },
    sectionTitle: {
        margin: '0 0 16px 0',
        fontSize: '1.125rem',
        fontWeight: '600',
        color: '#1f2937',
        borderBottom: '2px solid #e5e7eb',
        paddingBottom: '8px',
    },
    formRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px',
        marginBottom: '16px',
    },
    formGroup: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minWidth: '200px',
    },
    formGroupFull: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    formGroupCheckbox: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        minWidth: '180px',
    },
    checkboxGroup: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px',
        padding: '16px',
        backgroundColor: '#f8fafc',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
    },
    label: {
        marginBottom: '6px',
        fontWeight: '500',
        color: '#374151',
        fontSize: '0.875rem',
    },
    labelCheckbox: {
        fontWeight: '500',
        color: '#374151',
        fontSize: '0.875rem',
    },
    input: {
        padding: '12px 16px',
        borderRadius: '8px',
        border: '2px solid #e5e7eb',
        fontSize: '0.875rem',
        transition: 'all 0.2s ease',
        backgroundColor: '#ffffff',
        outline: 'none',
        '&:focus': {
            borderColor: '#667eea',
            boxShadow: '0 0 0 3px rgba(102, 126, 234, 0.1)',
        }
    },
    inputDisabled: {
        padding: '12px 16px',
        borderRadius: '8px',
        border: '2px solid #e5e7eb',
        fontSize: '0.875rem',
        backgroundColor: '#f9fafb',
        color: '#6b7280',
        cursor: 'not-allowed',
    },
    select: {
        padding: '12px 16px',
        borderRadius: '8px',
        border: '2px solid #e5e7eb',
        fontSize: '0.875rem',
        backgroundColor: '#ffffff',
        cursor: 'pointer',
        outline: 'none',
        transition: 'all 0.2s ease',
        '&:focus': {
            borderColor: '#667eea',
            boxShadow: '0 0 0 3px rgba(102, 126, 234, 0.1)',
        }
    },
    textarea: {
        padding: '12px 16px',
        borderRadius: '8px',
        border: '2px solid #e5e7eb',
        fontSize: '0.875rem',
        minHeight: '100px',
        resize: 'vertical',
        fontFamily: 'inherit',
        outline: 'none',
        transition: 'all 0.2s ease',
        '&:focus': {
            borderColor: '#667eea',
            boxShadow: '0 0 0 3px rgba(102, 126, 234, 0.1)',
        }
    },
    checkbox: {
        width: '18px',
        height: '18px',
        cursor: 'pointer',
        accentColor: '#667eea',
    },
    footer: {
        marginTop: '24px',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '12px',
        padding: '20px',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        border: '1px solid #e5e7eb',
    },
    saveButton: {
        backgroundColor: '#10b981',
        color: '#ffffff',
        padding: '12px 24px',
        borderRadius: '8px',
        border: 'none',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '0.875rem',
        display: 'flex',
        alignItems: 'center',
        transition: 'all 0.2s ease',
        boxShadow: '0 2px 4px rgba(16, 185, 129, 0.2)',
        '&:hover': {
            backgroundColor: '#059669',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 8px rgba(16, 185, 129, 0.3)',
        },
        '&:disabled': {
            backgroundColor: '#9ca3af',
            cursor: 'not-allowed',
            transform: 'none',
            boxShadow: 'none',
        }
    },
    cancelButton: {
        backgroundColor: '#ffffff',
        color: '#6b7280',
        padding: '12px 24px',
        borderRadius: '8px',
        border: '2px solid #e5e7eb',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '0.875rem',
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: '#f9fafb',
            borderColor: '#d1d5db',
        }
    },
    // Estilos para o input e botão do CNPJ
    formGroupCnpj: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minWidth: '280px',
    },
    cnpjInputGroup: {
        display: 'flex',
        alignItems: 'stretch',
        position: 'relative',
    },
    inputCnpj: {
        flex: 1,
        padding: '12px 16px',
        borderRadius: '8px 0 0 8px',
        border: '2px solid #e5e7eb',
        borderRight: 'none',
        fontSize: '0.875rem',
        outline: 'none',
        transition: 'all 0.2s ease',
        backgroundColor: '#ffffff',
        '&:focus': {
            borderColor: '#667eea',
            boxShadow: '0 0 0 3px rgba(102, 126, 234, 0.1)',
        }
    },
    cnpjSearchButton: {
        backgroundColor: '#667eea',
        color: '#ffffff',
        border: '2px solid #667eea',
        borderLeft: 'none',
        padding: '12px 16px',
        borderRadius: '0 8px 8px 0',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '48px',
        '&:hover': {
            backgroundColor: '#5a67d8',
            borderColor: '#5a67d8',
        },
        '&:disabled': {
            backgroundColor: '#9ca3af',
            borderColor: '#9ca3af',
            cursor: 'not-allowed',
        }
    },
};

export default ClienteModal;